export default __webpack_public_path__ + "static/media/success.9f1e7a3d.svg";